import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './index.css';
import { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import api from './api';
import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer/Footer';
import CollegePage from './components/SchoolsAndColleges/CollegePage';
import ProgramsDetails from './components/SchoolsAndColleges/Partials/ProgramsDetails';
import KelambakkamCampus from './components/Campus/KelambakkamCampus';
import TopLoadingBar from './components/TopLoadingBar';
import Alumni from './components/Pages/Alumni/Alumni';
import Registration from './components/Pages/Alumni/Partials/Registration';
import Milestones from './components/Pages/AboutUs/Milestones/Milestones';
import AboutCare from './components/Pages/AboutUs/AboutCare/AboutCare';
import Approval from './components/Pages/AboutUs/Approval/Approval';
import CareKonnect from './components/Pages/Care_Konnect/Care_Konnect';
import Library from './components/Pages/AboutUs/Library/Library';
import Policy from './components/Pages/AboutUs/Library/Policy';
import Collections from './components/Pages/AboutUs/Library/Collections';
import Eresources from './components/Pages/AboutUs/Library/Eresources';
import Openaccess from './components/Pages/AboutUs/Library/Openaccess';
import Sports from './components/Pages/FacultyandStaffs/Sports/Sports';
import OutreachActivities from './components/Pages/Others/OutreachActivities/OutreachActivities';
import Nss from './components/Pages/Others/Nss/Nss';
import Centers from './components/Pages/Others/Centers/Centers';
import CentersDemo from './components/Pages/Others/CentersDemo/Centers';
import Cme from './components/Pages/Others/Cme/Cme';
import SustainabilityPractice from './components/Pages/Others/SustainabilityPractice/SustainabilityPractice';
import AnnualReports from './components/Pages/Others/AnnualReports/AnnualReports';
import CodeOfConduct from './components/Pages/Others/CodeOfConduct/CodeOfConduct';
import Rti from './components/Pages/Others/Rti/Rti';
import Esanad from './components/Pages/Others/Esanad/Esanad';
import ValueAddedCourse from './components/Pages/Others/ValueAddedCourse/ValueAddedCourse';
import ReportCyberCrime from './components/Pages/Others/ReportCyberCrime/ReportCyberCrime';
import Maintenance from './components/Pages/Others/Maintainence/Maintainence';
import EnvironmentalClearance from './components/Pages/Others/EnvirinmentalClearance/EnvironmentalClearance';
import FacultyAwards from './components/Pages/FacultyandStaffs/FacultyAwards/FacultyAwards';
import InnovationAwards from './components/Pages/FacultyandStaffs/InnovationAwards/InnovationAwards';
import InternCare from './components/Pages/FacultyandStaffs/InternCare/InternCare';
import Hostel from './components/Pages/FacultyandStaffs/Hostel/Hostel';
import Transport from './components/Pages/FacultyandStaffs/Transport/Transport';
import PgApartment from './components/Pages/FacultyandStaffs/PgApartment/PgApartment';
import CommitteeCouncil from './components/Pages/Academics/CommitteeCouncil/CommiteeCouncil';
import FacultyDevelopment from './components/Pages/Academics/FacultyDevelopment/FacultyDevelopment';
import IhecFaculty from './components/Pages/Academics/IhecFaculty/IhecFaculty';
import Iaec from './components/Pages/Academics/Iaec/Iaec';
import Nad from './components/Pages/Academics/Nad/Nad';
import ProjectDissertation from './components/Pages/Academics/ProjectDissertation/ProjectDissertation';
import Examination from './components/Pages/Academics/Examination/Examination';
import VariousCommittee from './components/Pages/Academics/VariousCommittee/VariousCommittee';
import Nisp from './components/Pages/Academics/Nisp/Nisp';
import AcademicBank from './components/Pages/Academics/AcademicBank/AcademicBank';
import Careers from './components/Pages/Careers/Careers';
import PrivacyPolicy from './components/CampusLife/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './components/CampusLife/TermsConditions/TermsConditions';
import RefundPolicy from './components/CampusLife/RefundPolicy/RefundPolicy';
import CampusFacilities from './components/CampusLife/CampusFacilities/CampusFacilities';
import ProspectiveStudent from './components/QuickLinks/ProspectiveStudent/ProspectiveStudent';
import ResearchOverview from './components/Pages/Research/ResearchOverview';
import ResearchPhdProgram from './components/Pages/Research/ResearchPhdProgram';
import ResearchMou from './components/Pages/Research/ResearchMou';
import ResearchPublications from './components/Pages/Research/ResearchPublications';
import ResearchMedicalJourney from './components/Pages/Research/ResearchMedicalJourney';
import ResearchEContents from './components/Pages/Research/ResearchEContents';
import ResearchCDCT from './components/Pages/Research/ResearchCDCT';
import StudentLifeDetails from './components/SchoolsAndColleges/Partials/StudentLifeDetails';
import Blog from './components/Blog/Blog';
import BlogDetails from './components/Blog/partials/BlogDetails';
import SafetySecurity from './components/Pages/FacultyandStaffs/SafetySecurity/SafetySecurity';
import StudentSports from './components/Pages/FacultyandStaffs/Sports/Partials/StudentSports';
import StaffSports from './components/Pages/FacultyandStaffs/Sports/Partials/StaffSports';
import TournamentSports from './components/Pages/FacultyandStaffs/Sports/Partials/TournamentSports';
import OurCampus from './components/CampusLife/OurCampus/OurCampus';
import GeneralHospital from './components/QuickLinks/GeneralHospital/GeneralHospital';
import GeneralDepartment from './components/QuickLinks/GeneralHospital/GeneralDepartments';
import NoticeDataTable from './components/QuickLinks/NoticeDatatable/NoticeDatatable';
import FacultyList from './components/QuickLinks/GeneralHospital/FacultyList';
import AlumniRegistrationForm from './components/Form/AlumniRegistrationForm';
import AlumniFeedbackForm from './components/Form/AlumniFeedbackForm';
import DepartmentListPage from './components/QuickLinks/GeneralHospital/DepartmentListPage';
import DynamicGenDepartments from './components/QuickLinks/GeneralHospital/DynamicGenDepartments';
import HostelDemo from './components/Pages/FacultyandStaffs/Hostel/HostelDemo';

import ProspectiveStudentDemo from './components/QuickLinks/ProspectiveStudent/ProspectiveStudentDemo';
import SchoolsCollegesFacultyList from './components/SchoolsAndColleges/Partials/FacultyList';
import FacultyShow from './components/Pages/Others/FacultyShow/FacultyShow';
import Moa from './components/Pages/Others/Moa/Moa';
import SeoManager from './SeoManager';
import RouteResolver from './components/RouteResolver';

function CanonicalUrl() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = window.location.origin + pathname;
  }, [pathname]);

  return null;
}

const AppContent = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/menus`);
        setMenus(response.data.data);
      } catch (err) {
        console.error("Error fetching menus:", err);
      }
    };
    fetchMenus();
  }, []);

  const hasTopMenu = menus.some(menu => menu.type === "top-menu");

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Toaster position="top-center" />
      <SeoManager />
      <CanonicalUrl />
      <TopLoadingBar loading={loading} />
      <Header />
      <main id="main-content" className='main-page-wrapper'>
        <Routes location={location}>
          <Route path="/" element={<Home hasTopMenu={hasTopMenu} />} />
          <Route path="/:slug" element={<RouteResolver />} />
          <Route path="/:miniSlug/:slug" element={<CollegePage />} />
          <Route path="/:miniSlug/:collegeSlug/programs/:programSlug" element={<ProgramsDetails />} />
          <Route path='/:miniSlug/:slug/student-life' element={<StudentLifeDetails />} />
          <Route path='/campus/:campus_slug' element={<KelambakkamCampus />} />
          <Route path='/alumni' element={<Alumni />} />
          <Route path='/register-form' element={<Registration />} />
          <Route path='/milestones' element={<Milestones />} />
          <Route path='/about-care' element={<AboutCare />} />
          <Route path='/approval' element={< Approval />} />
          <Route path='/care-konnect' element={< CareKonnect />} />
          <Route path='/library' element={<Library />} />
          <Route path='/library/policy' element={<Policy />} />
          <Route path='/library/collections' element={<Collections />} />
          <Route path='/library/eresources' element={<Eresources />} />
          <Route path='/library/openaccess' element={<Openaccess />} />
          <Route path='/sports' element={<Sports />} />
          <Route path='/sports/highlights/:slug' element={<StudentSports />} />
          <Route path='/staffsports' element={<StaffSports />} />
          <Route path='/tournamentsports' element={<TournamentSports />} />
          <Route path='/outreachactivities' element={<OutreachActivities />} />
          <Route path='/nss' element={<Nss />} />
          <Route path='/centers' element={<Centers />} />
          <Route path='/centersdemo' element={<CentersDemo />} />
          <Route path='/cme' element={<Cme />} />
          <Route path='/sustainabilitypractice' element={<SustainabilityPractice />} />
          <Route path='/annualreports' element={<AnnualReports />} />
          <Route path='/codeofconduct' element={<CodeOfConduct />} />
          <Route path='/rti' element={<Rti />} />
          <Route path='/esanad' element={<Esanad />} />
          <Route path='/valueaddedcourse' element={<ValueAddedCourse />} />
          <Route path='/reportcybercrime' element={<ReportCyberCrime />} />
          <Route path='/maintainence' element={<Maintenance />} />
          <Route path='/environmentalclearance' element={<EnvironmentalClearance />} />
          <Route path='/facultyawards' element={<FacultyAwards />} />
          <Route path='/innovationawards' element={<InnovationAwards />} />
          <Route path='/interncare' element={<InternCare />} />
          <Route path='/hostel' element={<Hostel />} />
          <Route path='/hostel/demo' element={<HostelDemo />} />
          <Route path='/transport' element={<Transport />} />
          <Route path='/pg' element={<PgApartment />} />
          <Route path='/committeecouncil' element={<CommitteeCouncil />} />
          <Route path='/facultydevelopment' element={<FacultyDevelopment />} />
          <Route path='/ihecfaculty' element={<IhecFaculty />} />
          <Route path='/iaec' element={<Iaec />} />
          <Route path='/variouscommittee' element={<VariousCommittee />} />
          <Route path='/nisp' element={<Nisp />} />
          <Route path='/nad' element={<Nad />} />
          <Route path='/projectdissertation' element={<ProjectDissertation />} />
          <Route path='/examination' element={<Examination />} />
          <Route path='/academicbank' element={<AcademicBank />} />
          <Route path='/careers' element={<Careers/>} />
          <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
          <Route path='/termscondition' element={<TermsConditions/>} />
          <Route path='/refundpolicy' element={<RefundPolicy/>} />
          <Route path='/common-facilities' element={<CampusFacilities/>} />
          <Route path='/our-campus' element={<OurCampus/>} />
          <Route path='/prospectivestudent' element={<ProspectiveStudent/>} />
          <Route path='/prospectivestudent/demo' element={<ProspectiveStudentDemo/>} />
          <Route path='/blog' element={<Blog/>} />
          <Route path='/blog/:slug' element={<BlogDetails />} />
          <Route path='/safety' element={<SafetySecurity />} />
          <Route path='/general_hospital' element={<GeneralHospital />} />
          <Route path='/general_department' element={<GeneralDepartment />} />
          <Route path='/department-list' element={<DepartmentListPage />} />
          <Route path='/department/:slug' element={<DynamicGenDepartments />} />
          <Route path='/circulars' element={<NoticeDataTable />} />
          <Route path='/faculty-list' element={<FacultyList />} />

          {/* Research */}
          <Route path='/research' element={<ResearchOverview />} />
          <Route path='/research-phd' element={<ResearchPhdProgram />} />
          <Route path='/research-mou' element={<ResearchMou />} />
          <Route path='/research-publications' element={<ResearchPublications />} />
          <Route path='/research-medical-journey' element={<ResearchMedicalJourney />} />
          <Route path='/research-econtents' element={<ResearchEContents />} />
          <Route path='/research-cdct' element={<ResearchCDCT />} />

          <Route path='/alumni-registration' element={<AlumniRegistrationForm />} />
          <Route path='/alumni-feedback' element={<AlumniFeedbackForm />} />
          <Route path='/:miniSlug/:slug/faculty-list' element={<SchoolsCollegesFacultyList />} />
          <Route path="/faculty-show/:lastslug" element={<FacultyShow />} />
          <Route path='/moa' element={<Moa />} />
        
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;